import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=5cd5eaa8&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "styles/components/appMain.css?vue&type=style&index=0&id=5cd5eaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5eaa8",
  null
  
)

export default component.exports